import PageLayout from 'pages/StudentSubmissions/PageLayout';
import PageProvider from 'pages/StudentSubmissions/PageProvider';

const StudentSubmissionsPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default StudentSubmissionsPage;
